export const LOCAL_FILTER_FIELDS = []